// extracted by mini-css-extract-plugin
export default {"label":"profile_input_label__NK73F","inputLabel":"profile_input_inputLabel__whvkH typography_text--sm__BgKHZ"};